import { NoResult } from '@devex/devex-shared';
import { HttpService } from './http-service';
import { ShippingZonesEntity } from '../models/shipping-zones-entity';

export class ShippingZonesService {
	public static readonly id = 'shipping-zones-service';

	public constructor(private readonly _httpService: HttpService) {}

	public async get(): Promise<ShippingZonesEntity> {
		const shippingZones = await this._httpService.get<ShippingZonesEntity>('api/shipping-zones');

		return shippingZones;
	}

	public async save(shippingZones: ShippingZonesEntity): Promise<NoResult> {
		await this._httpService.post('api/shipping-zones', shippingZones);

		return NoResult.instance;
	}
}
